import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _BaseTakeBody;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
/* eslint "jsx-a11y/no-noninteractive-tabindex": "warn" */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { jsx } from '@instructure/emotion';
import { generateDisplayPositions } from '@instructure/quiz-core';
import { TakeProgress } from '../TakeProgress';
import { TakeItem } from '../TakeItem';
import { TakeStimulus } from '../TakeStimulus';
import t from '@instructure/quiz-i18n/format-message';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
var BaseTakeBody = /*#__PURE__*/function (_Component) {
  function BaseTakeBody() {
    var _this2;
    _classCallCheck(this, BaseTakeBody);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, BaseTakeBody, [].concat(args));
    _defineProperty(_this2, "itemRef", null);
    _defineProperty(_this2, "setRef", function (itemRef) {
      _this2.itemRef = itemRef;
    });
    _defineProperty(_this2, "renderAllItems", function () {
      return generateDisplayPositions(_this2.props.sessionItems).map(function (si) {
        return _this2.renderSessionItem(si.record);
      });
    });
    _defineProperty(_this2, "renderCurrentItem", function () {
      var positionType = _this2.props.useBolaPosition ? 'bolaPosition' : 'position';
      var item = _this2.props.sessionItems.find(function (item) {
        return item.get(positionType) == _this2.props.currentSessionItemPosition;
      });
      return _this2.renderOQAAT(item);
    });
    return _this2;
  }
  _inherits(BaseTakeBody, _Component);
  return _createClass(BaseTakeBody, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var currentSessionItemChanged = this.props.currentSessionItemPosition !== prevProps.currentSessionItemPosition;
      var _this$props = this.props,
        isOneQuestionAtATime = _this$props.isOneQuestionAtATime,
        focusCurrentSessionItem = _this$props.focusCurrentSessionItem,
        focusTitleAndInstructions = _this$props.focusTitleAndInstructions;
      if (isOneQuestionAtATime && (focusCurrentSessionItem || currentSessionItemChanged) && !focusTitleAndInstructions) {
        this.focus();
        this.props.clearFocusCurrentSessionItem();
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      var _this3 = this;
      if (this.itemRef) {
        // use setTimeout to break away from RCE destruction that loses focus
        setTimeout(function () {
          _this3.itemRef.focus();
        }, 50);
      }
    }
  }, {
    key: "renderProgressBar",
    value: function renderProgressBar(sessionItem) {
      if (this.props.showProgress) {
        return jsx(TakeProgress, {
          currentQuestionPosition: this.props.isBuildOnLastAttempt ? sessionItem.bolaPosition : this.props.currentSessionItemPosition,
          totalQuestionCount: this.props.isBuildOnLastAttempt ? this.props.bolaSessionItemsCount : this.props.sessionItemsCount
        });
      }
    }
  }, {
    key: "renderOQAAT",
    value: function renderOQAAT(sessionItem) {
      if (!sessionItem) {
        return;
      }
      return jsx("div", null, this.renderProgressBar(sessionItem), this.renderSessionItem(sessionItem));
    }
  }, {
    key: "renderSessionItem",
    value: function renderSessionItem(sessionItem) {
      if (sessionItem.isStimulus) {
        return jsx("div", {
          tabIndex: "-1",
          key: sessionItem.position,
          ref: this.setRef,
          "aria-label": t('Stimulus'),
          role: "group"
        }, jsx(TakeStimulus, {
          isOqaat: this.props.isOneQuestionAtATime,
          sessionItem: sessionItem,
          quizSessionId: this.props.quizSessionId,
          lockDown: this.props.lockDown
        }));
      }
      return jsx("div", {
        role: "form",
        css: this.props.styles.root.itemWrapper,
        ref: this.setRef,
        tabIndex: "-1",
        key: sessionItem.position
      }, jsx(TakeItem, {
        quizSessionId: this.props.quizSessionId,
        sessionItem: sessionItem,
        lockDown: this.props.lockDown,
        separatorConfig: this.props.separatorConfig
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var body = this.props.isOneQuestionAtATime ? this.renderCurrentItem() : this.renderAllItems();
      return jsx("div", {
        css: this.props.styles.root
      }, body);
    }
  }]);
}(Component);
_BaseTakeBody = BaseTakeBody;
_defineProperty(BaseTakeBody, "displayName", 'TakeBody');
_defineProperty(BaseTakeBody, "componentId", "Quizzes".concat(_BaseTakeBody.displayName));
_defineProperty(BaseTakeBody, "propTypes", {
  currentSessionItemPosition: PropTypes.number.isRequired,
  clearFocusCurrentSessionItem: PropTypes.func.isRequired,
  focusCurrentSessionItem: PropTypes.bool,
  isOneQuestionAtATime: PropTypes.bool.isRequired,
  quizSessionId: PropTypes.string.isRequired,
  sessionItems: ImmutablePropTypes.list.isRequired,
  sessionItemsCount: PropTypes.number.isRequired,
  showProgress: PropTypes.bool.isRequired,
  lockDown: PropTypes.bool,
  isBuildOnLastAttempt: PropTypes.bool,
  bolaSessionItemsCount: PropTypes.number,
  useBolaPosition: PropTypes.bool,
  focusTitleAndInstructions: PropTypes.bool,
  separatorConfig: PropTypes.shape({
    decimalSeparator: PropTypes.string,
    thousandSeparator: PropTypes.string
  }),
  styles: PropTypes.object
});
_defineProperty(BaseTakeBody, "defaultProps", {
  focusCurrentSessionItem: false,
  lockDown: false,
  isBuildOnLastAttempt: false,
  bolaSessionItemsCount: null,
  useBolaPosition: false
});
export var TakeBody = withStyleOverrides(generateStyle, generateComponentTheme)(BaseTakeBody);
export default TakeBody;